module.exports = __webpack_public_path__ + "static/media/hadoop.ce5c03f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/hadoop.png
// module id = 470
// module chunks = 0